// Auto-generated resource for Legal — DO NOT EDIT.
// Regenerate via `dotnet run --project backend/tools/BackendTypesGenerator`.
// Projection of the backend resource JSON — keys, value catalogs (per
// culture), and string-literal unions. Hand-editing drifts from the source.

export const LegalKeys = {
  Terms: {
    Title: 'Legal.Terms.Title',
    MetaDescription: 'Legal.Terms.MetaDescription',
    Heading: 'Legal.Terms.Heading',
    Framing: 'Legal.Terms.Framing',
    Effective: 'Legal.Terms.Effective',
  },
  Privacy: {
    Title: 'Legal.Privacy.Title',
    MetaDescription: 'Legal.Privacy.MetaDescription',
    Heading: 'Legal.Privacy.Heading',
    Framing: 'Legal.Privacy.Framing',
    Effective: 'Legal.Privacy.Effective',
  },
  ThirdParty: {
    Title: 'Legal.ThirdParty.Title',
    MetaDescription: 'Legal.ThirdParty.MetaDescription',
    Heading: 'Legal.ThirdParty.Heading',
    Framing: 'Legal.ThirdParty.Framing',
    ModelsHeading: 'Legal.ThirdParty.ModelsHeading',
    ModelsIntro: 'Legal.ThirdParty.ModelsIntro',
    ModelsUnavailable: 'Legal.ThirdParty.ModelsUnavailable',
    LicenseLabel: 'Legal.ThirdParty.LicenseLabel',
    UpstreamLabel: 'Legal.ThirdParty.UpstreamLabel',
    WeightsLabel: 'Legal.ThirdParty.WeightsLabel',
    NoticeLabel: 'Legal.ThirdParty.NoticeLabel',
    SoftwareHeading: 'Legal.ThirdParty.SoftwareHeading',
    SoftwareLicense: 'Legal.ThirdParty.SoftwareLicense',
  },
} as const;

export const LegalValues = {
  'default': {
    'Privacy.Effective': 'Effective: {Date}',
    'Privacy.Framing': 'VoiceDojo is a playful, helpful tool for practising voice and communication — a place to treat your voice as an instrument and explore. We keep what we collect small, and your recordings stay yours.',
    'Privacy.Heading': 'Privacy Policy',
    'Privacy.MetaDescription': 'VoiceDojo Privacy Policy — what we collect, how we use it, retention, and your rights.',
    'Privacy.Title': 'Privacy Policy · VoiceDojo',
    'Terms.Effective': 'Effective: {Date}',
    'Terms.Framing': 'VoiceDojo is a playful, helpful tool for practising voice and communication — a place to treat your voice as an instrument and explore. Here’s the plain-English deal between us.',
    'Terms.Heading': 'Terms of Service',
    'Terms.MetaDescription': 'VoiceDojo Terms of Service — credits, retention, subscription, and contact.',
    'Terms.Title': 'Terms of Service · VoiceDojo',
    'ThirdParty.Framing': 'Offline mode and background blur run software and models made by others. We download them from our own domain and they run on your device. Here is what they are and the terms they come under.',
    'ThirdParty.Heading': 'Third-party notices',
    'ThirdParty.LicenseLabel': 'Licence',
    'ThirdParty.MetaDescription': 'Licences and attributions for the offline AI models and software VoiceDojo ships.',
    'ThirdParty.ModelsHeading': 'Offline AI models',
    'ThirdParty.ModelsIntro': 'Each model below is one you can pick in offline mode. We serve exactly the versions listed.',
    'ThirdParty.ModelsUnavailable': 'The model list could not be loaded. Check your connection and reload this page.',
    'ThirdParty.NoticeLabel': 'Notice',
    'ThirdParty.SoftwareHeading': 'Software',
    'ThirdParty.SoftwareLicense': 'Apache License 2.0',
    'ThirdParty.Title': 'Third-party notices · VoiceDojo',
    'ThirdParty.UpstreamLabel': 'Original model',
    'ThirdParty.WeightsLabel': 'MLC weights (pinned commit)',
  },
  'vi-VN': {
    'Privacy.Effective': 'Có hiệu lực từ: {Date}',
    'Privacy.Framing': 'VoiceDojo là một công cụ vui vẻ và hữu ích để luyện giọng nói và giao tiếp — một nơi để xem giọng nói của bạn như một nhạc cụ và khám phá nó. Chúng tôi thu thập càng ít càng tốt, và các bản thu vẫn là của bạn.',
    'Privacy.Heading': 'Chính sách Bảo mật',
    'Privacy.MetaDescription': 'Chính sách Bảo mật của VoiceDojo — chúng tôi thu thập gì, dùng ra sao, lưu bao lâu, và quyền của bạn.',
    'Privacy.Title': 'Chính sách Bảo mật · VoiceDojo',
    'Terms.Effective': 'Có hiệu lực từ: {Date}',
    'Terms.Framing': 'VoiceDojo là một công cụ vui vẻ và hữu ích để luyện giọng nói và giao tiếp — một nơi để xem giọng nói của bạn như một nhạc cụ và khám phá nó. Đây là thỏa thuận giữa chúng ta, viết bằng ngôn ngữ đời thường.',
    'Terms.Heading': 'Điều khoản Dịch vụ',
    'Terms.MetaDescription': 'Điều khoản Dịch vụ của VoiceDojo — tín dụng, lưu trữ bản thu, gói đăng ký và liên hệ.',
    'Terms.Title': 'Điều khoản Dịch vụ · VoiceDojo',
    'ThirdParty.Framing': 'Chế độ ngoại tuyến và làm mờ nền chạy phần mềm và mô hình do bên khác tạo ra. Chúng được tải về từ tên miền của chính chúng tôi và chạy trên thiết bị của bạn. Dưới đây là danh sách và các điều khoản áp dụng.',
    'ThirdParty.Heading': 'Thông báo bên thứ ba',
    'ThirdParty.LicenseLabel': 'Giấy phép',
    'ThirdParty.MetaDescription': 'Giấy phép và ghi công cho các mô hình AI ngoại tuyến và phần mềm mà VoiceDojo cung cấp.',
    'ThirdParty.ModelsHeading': 'Mô hình AI ngoại tuyến',
    'ThirdParty.ModelsIntro': 'Mỗi mô hình dưới đây là một lựa chọn trong chế độ ngoại tuyến. Chúng tôi cung cấp đúng các phiên bản được liệt kê.',
    'ThirdParty.ModelsUnavailable': 'Không tải được danh sách mô hình. Hãy kiểm tra kết nối mạng và tải lại trang này.',
    'ThirdParty.NoticeLabel': 'Thông báo',
    'ThirdParty.SoftwareHeading': 'Phần mềm',
    'ThirdParty.SoftwareLicense': 'Apache License 2.0',
    'ThirdParty.Title': 'Thông báo bên thứ ba · VoiceDojo',
    'ThirdParty.UpstreamLabel': 'Mô hình gốc',
    'ThirdParty.WeightsLabel': 'Trọng số MLC (commit cố định)',
  },
} as const;

